import React from "react";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Text,
  VStack,
} from "@chakra-ui/react";

interface DetailsAccordionProps {
  id?: string;
  title: string;
  children: React.ReactNode;
}

export const DetailsAccordion = ({
  id,
  title,
  children,
}: DetailsAccordionProps) => (
  <>
    <Accordion allowToggle id={id}>
      <AccordionItem borderTop="none">
        <AccordionButton px={0}>
          <Box flex="1" textAlign="left">
            <Text fontWeight="bold" fontSize="md">
              {title}
            </Text>
          </Box>
          <AccordionIcon
            height={"24px"}
            width={"24px"}
            bg="blue.500"
            borderRadius={"3xl"}
            color="white"
            _hover={{ bg: "blue.300" }}
          />
        </AccordionButton>

        <AccordionPanel pb={4} px={0}>
          <VStack alignItems="baseline" spacing="6px">
            {children}
          </VStack>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  </>
);
